/*
 * @Author: Zhouqi
 * @Date: 2025-11-27 15:54:33
 * @LastEditors: Ryan
 * @LastEditTime: 2026-02-04
 */
import dynamic from 'next/dynamic';
import React from 'react';

import FaceSwapSkeleton from '@/3.0/face-swap/_components/face-swap-skeleton';
import { SHOWCASE_PRELOAD_IMAGE } from '@/3.0/face-swap/seo/FaceSwapShowcase';
import { Introduction } from '@/components/container';
import DelayedRender from '@/components/DelayRender';
import Footer from '@/components/Footer';
import Layout from '@/components/layout';
import SEOHead from '@/landing/components/SEOHead';
import { createSoftwareAppSchema } from '@/landing/utils/structuredData';

const FaceSwapper = dynamic(() => import('../../3.0/face-swap/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <FaceSwapSkeleton />
    </DelayedRender>
  ),
});

const SEOSections = dynamic(() => import('../../3.0/face-swap/seo'), {
  ssr: true,
});

// SEO constants
const PAGE_TITLE = 'AI Face Swap Online Free - Swap Faces in Photos & Videos | FalcoCut';
const META_DESCRIPTION =
  'Swap faces in photos and videos instantly with FalcoCut AI Face Swap. Realistic results in seconds — no editing skills needed. Try free online face swap now.';
const CURRENT_URL = 'https://falcocut.ai/face-swap';

// Structured data
const structuredData = createSoftwareAppSchema({
  name: 'FalcoCut AI Face Swap',
  description: META_DESCRIPTION,
  url: CURRENT_URL,
  ratingValue: '4.8',
  ratingCount: '2350',
  featureList: [
    'AI-powered face swap in videos',
    'Photo face swap with one click',
    'Multi-face detection and swap',
    'Up to 4K resolution output',
    'Fast and secure processing',
    'No editing skills required',
  ],
});

const FaceSwapperPage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
  getExtraContent?: () => React.ReactNode;
} = () => {
  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={META_DESCRIPTION}
        url={CURRENT_URL}
        imageAlt="FalcoCut AI Face Swap"
        publishedTime="2025-11-27"
        modifiedTime="2026-02-04"
        structuredData={structuredData}
        preloadImages={[SHOWCASE_PRELOAD_IMAGE]}
      />

      <FaceSwapper />
    </>
  );
};

FaceSwapperPage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

FaceSwapperPage.getExtraContent = () => {
  return (
    <Introduction>
      <SEOSections />
      <Footer />
    </Introduction>
  );
};

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default FaceSwapperPage;
